import { useEffect, useRef, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { Loader2 } from 'lucide-react'
import { SUMIT_WHATSAPP_URL } from '@/lib/supabase'

export default function PaymentCallbackPage() {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const [error, setError] = useState('')
  const calledRef = useRef(false)

  useEffect(() => {
    if (calledRef.current) return
    calledRef.current = true

    const paymentId = searchParams.get('payment_id')
    const valid = searchParams.get('Valid') ?? searchParams.get('valid')
    const transactionId = searchParams.get('TransactionID') ?? searchParams.get('transactionId')

    if (!paymentId) {
      navigate('/payment/cancel', { replace: true })
      return
    }

    ;(async () => {
      try {
        const res = await fetch(SUMIT_WHATSAPP_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'payment_callback',
            payment_id: paymentId,
            sumit_transaction_id: transactionId ?? '',
            valid: valid ?? '0',
          }),
        })

        const json = await res.json()

        if (json.ok && json.orgId) {
          const connectUrl = json.connectUrl ?? `https://wa.otomator.pro/connect/${json.orgId}`
          navigate(
            `/payment/success?orgId=${encodeURIComponent(json.orgId)}&connectUrl=${encodeURIComponent(connectUrl)}`,
            { replace: true },
          )
        } else {
          navigate('/payment/cancel', { replace: true })
        }
      } catch (err) {
        setError(err instanceof Error ? err.message : 'שגיאה לא צפויה')
      }
    })()
  }, [navigate, searchParams])

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center px-4" style={{ background: '#0f1117' }} dir="rtl" lang="he">
        <div className="text-center max-w-md">
          <div
            className="px-6 py-4 rounded-xl text-sm mb-6"
            style={{ background: '#ef444420', color: '#f87171', border: '1px solid #ef444440' }}
          >
            {error}
          </div>
          <button
            onClick={() => navigate('/whatsapp/pricing')}
            className="px-6 py-2.5 rounded-xl text-sm font-medium text-white transition-colors"
            style={{ background: '#252836', border: '1px solid #2d3148' }}
          >
            חזור לדף המחירים
          </button>
        </div>
      </div>
    )
  }

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ background: '#0f1117' }} dir="rtl" lang="he">
      <div className="text-center">
        <Loader2 className="animate-spin mx-auto mb-4" size={48} style={{ color: '#4ade80' }} />
        <p className="text-lg font-medium text-white">מעבד את התשלום...</p>
        <p className="text-sm mt-2" style={{ color: '#6b7280' }}>אנא המתן, אל תסגור את הדף</p>
      </div>
    </div>
  )
}
